import { DashboardModule, Button } from '@domain-group/suit-theme'

import useCampaigns from '@hooks/useCampaigns'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-light-svg-icons'

import CampaignListItem from './CampaignListItem'

const overviewCampaignScreenUrl = '#/agency/dashboard/agencies/all/overview/campaigns'

const navigateToOverviewCampaign = () => {
  window.location.hash = overviewCampaignScreenUrl
}

const RecentCampaigns = () => {
  const campaignsPayload = useCampaigns({
    filters: {
      agency_marketing: 'true',
      limit: 20,
      order_by: 'updated_at desc',
    },
    performHttpRequests: true,
    sortBy: 'cache_key desc',
  })

  const {
    filteredCampaigns,
    hasFilteredCampaigns,
    loading,
  } = campaignsPayload

  return (
    <DashboardModule
      boxProps={{
        borderBottom: `${loading ? 'none' : ''}`,
        marginBottom: 'large',
      }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Recent Campaigns"
    >
      {!loading && !hasFilteredCampaigns && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Campaigns Present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {hasFilteredCampaigns && (
        <>
          {/*
           // @ts-expect-error TS2322 */}
          <DashboardModule.ScrollableSection maxHeight={600}>
            {filteredCampaigns.map(campaign => (
              <CampaignListItem campaign={campaign} />
            ))}
          </DashboardModule.ScrollableSection>

          <DashboardModule.Footer>
            <DashboardModule.FooterRight>
              <Button
                buttonStyle="secondaryUtility"
                icon={<FontAwesomeIcon icon={faSpinner} />}
                onClick={() => navigateToOverviewCampaign()}
                size="medium"
              >
                View All
              </Button>
            </DashboardModule.FooterRight>
          </DashboardModule.Footer>
        </>
      )}
    </DashboardModule>
  )
}

export default RecentCampaigns
